// extracted by mini-css-extract-plugin
export default {"container":"ImageCropper_container__7WC7-","saveButton":"ImageCropper_saveButton__7dOFk"};